import React, { ReactNode } from 'react';
import styled from 'styled-components';

import HeaderMobile from '#/components/layout/header/HeaderMobile';
import { useSelector } from '#/reduxState/store';
import { scrollbarStyle } from '#/styleShared';

import FeaturePanel from './FeaturePanel';
import MobileHeaderText from './MobileHeaderText';

const OuterMargin = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;

  overflow-y: auto;
  ${scrollbarStyle}

  .isMobileStyle & {
    height: calc(100% - var(--mobileNavHeight));
    padding: 0;
  }
`;

const Wrapper = styled.div`
  display: block;
  max-width: 406px;
  width: 400px;
  border-radius: 5px;
  background: var(--elevation-light);

  .isMobileStyle & {
    border: none;
  }
  /* padding: $ {props => (props.noPadding ? 0 : '40px 0 100px')}; */
  /** y-auto is to fix verticall scroll */
  margin: auto auto;

  > h2 {
    margin: 0;
    padding: 24px;
  }
`;

const SubHeading = styled.div`
  padding: 0 24px 16px 24px;
  line-height: 1.5;
  color: var(--gray4c);
`;

type Props = {
  heading?: string;
  subHeading?: ReactNode;
  children: ReactNode;
  /* Disable mobile layout menus */
  noMobileMenus?: boolean;
  mobileBackGoTo?: string;
};

export default function AuthLayout({
  heading,
  subHeading,
  noMobileMenus,
  children,
  mobileBackGoTo,
}: Props) {
  const isMobile = useSelector(state => state.screen.isMobile);
  return (
    <>
      {!noMobileMenus && isMobile && (
        <>
          <HeaderMobile backGoTo={mobileBackGoTo || '/wallet/menu-mobile'}>
            {heading}
          </HeaderMobile>
          {subHeading && <MobileHeaderText>{subHeading}</MobileHeaderText>}
        </>
      )}
      <OuterMargin>
        <Wrapper>
          {(noMobileMenus || !isMobile) && (
            <>
              {heading && <h2>{heading}</h2>}
              {subHeading && <SubHeading>{subHeading}</SubHeading>}
            </>
          )}
          <FeaturePanel>{children}</FeaturePanel>
        </Wrapper>
      </OuterMargin>
    </>
  );
}
